import script from "./ContractStatusDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractStatusDisplay.vue?vue&type=script&setup=true&lang=js"

import "./ContractStatusDisplay.vue?vue&type=style&index=0&id=08f64d50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f64d50"]])

export default __exports__